import HttpRequest from './HttpRequest';

export default class AdomiComponentsService extends HttpRequest {
  static endpoint = 'adomi-components';

  static async getAll() {
    this.endpoint = 'adomi-components';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'adomi-components';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'adomi-components';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'adomi-components';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'adomi-components';
    const response = await this.put(id, data);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'adomi-components/create-primary-image';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'adomi-components/delete-primary-image';
    const response = await this.delete(data);
    return response;
  }
}
